import { render } from "./AboutCard.vue?vue&type=template&id=6dd7b442&scoped=true"
import script from "./AboutCard.vue?vue&type=script&lang=js"
export * from "./AboutCard.vue?vue&type=script&lang=js"

import "./AboutCard.vue?vue&type=style&index=0&id=6dd7b442&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dd7b442"]])

export default __exports__